import Vue from 'vue'
import Draggabilly from 'draggabilly'
import dialogState from './dialogState'
import { debounce } from 'lodash'

/**
 * 创建弹窗实例
 * @param Component
 * @param data {object}
 * @param renderChildren {function}
 * @param draggable {boolean}
 * @param sceneType {string}
 * @returns {*}
 */
export default function createComponent(Component, data, renderChildren, { draggable, sceneType }) {
  let proxy = new Vue({
    render(h) {
      let children = renderChildren && renderChildren(h)
      if (children && !Array.isArray(children)) {
        children = [children]
      }
      return h(
        Component,
        {
          ...data,
          class: {
            'drag-dialog__wrapper': draggable
          }
        },
        children || []
      )
    },
    mounted() {
      document.body.appendChild(this.$el)
      this.initDrag()
    },
    destroyed() {
      if (this.$el && this.$el.parentNode === document.body) {
        document.body.removeChild(this.$el)
      }
      if (draggable) {
        this.dragInstance?.destroy?.()
        window.removeEventListener('resize', this.resizePosition)
      }
    },
    methods: {
      initDrag() {
        // 当弹窗dialog容器渲染完成时
        if (!draggable) return
        window.addEventListener('resize', this.resizePosition)
        try {
          const dialogVmDom = this.$el.firstChild
          this.dragInstance = new Draggabilly(dialogVmDom, {
            handle: '.el-dialog__header',
            containment: document.body
          })
          this.dragInstance.on('dragEnd', () => {
            if (draggable) {
              dialogState.update(sceneType, {
                leftPx: dialogVmDom.style.left,
                topPx: dialogVmDom.style.top
              })
            }
          })
        } catch (e) {
          console.warn(e.message)
        }
      },
      // 自适应调整弹窗位置
      resizePosition: debounce(function() {
        if (!draggable || !this.dragInstance) return
        try {
          this.dragInstance.handleDragStart()
          this.dragInstance.handleDragMove(null, null, { x: 0, y: 0 })
          this.dragInstance.handleDragEnd()
          const dialogVmDom = this.$el.firstChild
          dialogState.update(sceneType, {
            leftPx: dialogVmDom.style.left,
            topPx: dialogVmDom.style.top
          })
        } catch (e) {
          console.warn(e.message)
        }
      }, 200)
    },
    store: this?.$store,
    router: this?.$router
  })

  proxy.$on('hook:mounted', () => {})

  proxy.$mount()

  const component = proxy.$children[0]
  component.$on('hook:destroyed', () => {
    proxy && proxy.$destroy()
    proxy && proxy.$nextTick(() => (proxy = null))
  })
  component.$updateProps = function(props) {
    if (!data.props) {
      data.props = {}
    }
    Object.assign(data.props, props)
    proxy.$forceUpdate()
  }
  return component
}
